import classNames from 'classnames';
import { Icon, IconProps } from '@components/icon';
import { Stack } from '@components/layout';
import { Body } from '@components/text';
import './BundleLock.scss';

export interface BundleLockProps {
  children: React.ReactNode;
  className?: string;
  /** Icon to display. Locked icon by default. */
  icon?: IconProps['name'];
  /** Size of the text and icon. Default large */
  size?: 'small' | 'large';
}

/**
 * BundleLock Component
 * @param children - Any React.ReactNode component.
 * @param className - Additional classNames for the component.
 * @param icon - Icon to display. Locked icon by default.
 * @param size - Size of the text and icon. Default large
 */
export const BundleLock: React.FC<BundleLockProps> = ({
  children,
  className,
  icon = 'lock-locked',
  size = 'large',
}) => (
  <Stack
    className={classNames('vds-bundle-lock', `vds-bundle-lock--${size}`, className)}
    gap="spacing-1"
    width="auto"
    alignItems="center">
    <Icon name={icon} size={size === 'large' ? 'medium' : 'small'} />
    <Body className="vds-bundle-lock__text" variant="body-02" size={size} color="tertiary">
      {children}
    </Body>
  </Stack>
);
